<div #chatbotMini class="chatbot-mini" id="phx-chatbot-mini">
</div>
